/*
 * 404.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 03 2023 mys Company
 */

const NotFound404 = () => {
  return <>NotFound</>;
};

export default NotFound404;
